import { create } from 'zustand';

/**
 * Which `?impersonate=` trigger has already been claimed on this page load.
 *
 * Module-scope, not per hook instance: `useImpersonation` is mounted by
 * ImpersonationBanner and EnrollQueueContext independently.
 * A per-instance ref let one page load fire one `start` POST per mount, and
 * those concurrent POSTs raced into two active RoleDelegation rows.
 *
 * Never released. A successful trigger reloads the page; a failed one is not
 * retried, which matches the old per-instance ref.
 */
interface ImpersonationTriggerState {
  claimedSlackId: string | null;
}

export const initialState: ImpersonationTriggerState = {
  claimedSlackId: null,
};

export const useImpersonationTriggerStore = create<ImpersonationTriggerState>(() => ({
  ...initialState,
}));

/** True for the first caller per `slackId`; false for every later caller. */
export function claimImpersonationTrigger(slackId: string): boolean {
  if (useImpersonationTriggerStore.getState().claimedSlackId === slackId) return false;
  useImpersonationTriggerStore.setState({ claimedSlackId: slackId });
  return true;
}
